// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zangoose: PokeData = {
  "id": 335,
  "name": "zangoose",
  "height": 13,
  "weight": 403,
  "base_experience": 160,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "leer",
    "quick-attack",
    "slash",
    "detect",
    "false-swipe",
    "fury-cutter",
    "pursuit",
    "metal-claw",
    "facade",
    "taunt",
    "revenge",
    "crush-claw",
    "aerial-ace",
    "close-combat",
    "embargo",
    "x-scissor",
    "switcheroo",
    "hone-claws",
    "power-trip"
  ],
  "moves": [
    "scratch",
    "leer",
    "quick-attack",
    "pursuit",
    "metal-claw",
    "aerial-ace",
    "close-combat",
    "refresh",
    "tri-attack",
    "purification",
    "growl",
    "supersonic",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 169,
    "item": null,
    "species": [
      {
        "name": "zangoose",
        "order": 363,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 133,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
